import state from './state'
import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'

const store = new window.Vuex.Store({
    state,
    mutations,
    getters,
    actions,
});

export default store;
